import React from 'react'
import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { ChevronDown } from 'lucide-react'

import { cn } from '../../utils/cn.js'

const Accordion = React.forwardRef((props, ref) => (
  <AccordionPrimitive.Root
    ref={ref}
    data-slot="accordion"
    {...props}
  />
))
Accordion.displayName = AccordionPrimitive.Root.displayName

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    data-slot="accordion-item"
    className={cn('tw-border-b', className)}
    {...props}
  />
))
AccordionItem.displayName = AccordionPrimitive.Item.displayName

const AccordionHeader = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Header
    ref={ref}
    data-slot="accordion-header"
    className={cn('tw-flex tw-items-center', className)}
    {...props}
  />
))
AccordionHeader.displayName = AccordionPrimitive.Header.displayName

const AccordionTrigger = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Trigger
      ref={ref}
      data-slot="accordion-trigger"
      className={cn(
        'tw-flex tw-flex-1 tw-items-center tw-justify-between tw-gap-2 tw-py-4 tw-text-left tw-text-sm tw-font-medium tw-transition-all hover:tw-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring [&[data-state=open]>svg]:tw-rotate-180',
        className,
      )}
      {...props}
    >
      {children}
      <ChevronDown
        aria-hidden="true"
        className="tw-h-4 tw-w-4 tw-shrink-0 tw-text-muted-foreground tw-transition-transform tw-duration-200"
      />
    </AccordionPrimitive.Trigger>
  ),
)
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Content
      ref={ref}
      data-slot="accordion-content"
      className="tw-overflow-hidden tw-text-sm data-[state=closed]:tw-animate-accordion-up data-[state=open]:tw-animate-accordion-down"
      {...props}
    >
      <div
        data-slot="accordion-content-inner"
        className={cn('tw-pb-4 tw-pt-0', className)}
      >
        {children}
      </div>
    </AccordionPrimitive.Content>
  ),
)
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionTrigger,
  AccordionContent,
}
